import React, { useState } from 'react';
import { CLIMATE_LOCATIONS } from '../../data/seasonalContent';
import '../../styles/explore.scss';

const MONTH_LABELS = ['Jan', 'Apr', 'Jul', 'Oct'];

function ClimateChart({ climateData }) {
	const [activeSlug, setActiveSlug] = useState(CLIMATE_LOCATIONS[0].slug);
	const location = CLIMATE_LOCATIONS.find((l) => l.slug === activeSlug);
	const rows = (climateData[activeSlug] || []).filter((c) => [1, 4, 7, 10].includes(c.month));
	const maxTemp = Math.max(...rows.map((r) => r.avg_high_c || 0), 30);
	const maxRain = Math.max(...rows.map((r) => r.rainfall_mm || 0), 400);

	return (
		<div className="climate-chart">
			<div className="climate-chart__tabs" role="tablist">
				{CLIMATE_LOCATIONS.map((loc) => (
					<button
						key={loc.slug}
						type="button"
						className={`climate-chart__tab${activeSlug === loc.slug ? ' is-active' : ''}`}
						onClick={() => setActiveSlug(loc.slug)}
					>
						{loc.name}
					</button>
				))}
			</div>

			{rows.length === 0 ? (
				<div className="climate-chart__empty">Climate data for {location && location.name} is being expanded — illustrative seasonal guidance is in the month-by-month guide above.</div>
			) : (
				<>
					<div className="climate-chart__bars">
						{rows.map((row) => (
							<div key={row.month} className="climate-chart__bar-group">
								<div
									className="climate-chart__bar"
									style={{ height: `${((row.avg_high_c || 0) / maxTemp) * 100}%` }}
									title={`High: ${row.avg_high_c}°C`}
								/>
								<div
									className="climate-chart__rain"
									style={{ height: `${((row.rainfall_mm || 0) / maxRain) * 60}%` }}
									title={`Rain: ${row.rainfall_mm}mm`}
								/>
								<span className="climate-chart__label">{MONTH_LABELS[[1, 4, 7, 10].indexOf(row.month)]}</span>
							</div>
						))}
					</div>
					<div className="climate-chart__legend">
						<span className="climate-chart__legend-temp">Avg high °C</span>
						<span className="climate-chart__legend-rain">Rainfall mm</span>
					</div>
					{rows.some((r) => r.notes) && (
						<p className="text-muted mt-3 mb-0" style={{ fontSize: '0.85rem' }}>
							{rows.map((r) => r.notes).filter(Boolean).join(' · ')}
						</p>
					)}
				</>
			)}
		</div>
	);
}

export default ClimateChart;
